<div class="header-box">
  <div class="d-flex align-items-center heading-box">
    <ng-icon [name]="
        mode == 'view'
          ? 'heroCircleStack'
          : mode == 'edit'
          ? 'heroPencilSquare'
          : 'heroPlusCircle'
      "></ng-icon>
    <div>
      <h2 *ngIf="mode">
        <small>{{ mode + " Attribute" | titlecase }}</small>
      </h2>
      <h2 *ngIf="formLoading; else loaded">
        <ngx-skeleton-loader [theme]="{ height: '20px', width: '200px' }"></ngx-skeleton-loader>
      </h2>
      <ng-template #loaded>
        <h2>{{ id ? metadataForm.get('label').value: "Add Attribute" }}</h2>
      </ng-template>
    </div>
  </div>
  <div class="d-flex justify-content-end align-items-center col-md-6 p-0">
    <button color="accent" mat-raised-button *ngIf="userService.permissionsValue['_CLAUSES_EDIT_'] && mode == 'view'"
      [routerLink]="['/app/attribute', 'edit', id]">
      Edit Attribute
    </button>
  </div>
</div>
<div class="inner-box">
  <mat-card class="without-expansion">
    <mat-card-content class="form-head">
      <div *ngIf="formLoading; else show">
        <ngx-skeleton-loader [theme]="{ height: '80px', width: '70%', margin: '0 auto'}"></ngx-skeleton-loader>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '40px'}"></ngx-skeleton-loader>
        </div>
        <div class="pt-3">
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ height: '50px', width: '30px', opacity: '0', float: 'right', visibility: 'hidden'}"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '50px', width: '10%', float: 'right'}"></ngx-skeleton-loader>
        </div>
      </div>
      <ng-template #show>
        <form [formGroup]="metadataForm" (ngSubmit)="saveAttribute()">
          <div class="col-md-12 d-flex p-0">
            <div class="col-md-4">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Label</mat-label>
                  <input type="text" matInput autocomplete="off" formControlName="label" [errorStateMatcher]="matcher">
                  <mat-error *ngIf="metadataForm.get('label').hasError('required')">
                    Label is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div [ngClass]="[2, 12, 15].includes(metadataForm.get('metaDataTypeId').value) ? 'col-md-4' : 'col-md-8'">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Select Data Type</mat-label>
                  <mat-select formControlName="metaDataTypeId" [errorStateMatcher]="matcher">
                    <mat-option *ngFor="let data of dataTypes" [value]="data.metaDataTypeId">{{ data.name
                      }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="metadataForm.get('metaDataTypeId').hasError('required')">
                    Data Type is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4" *ngIf="showDropdown">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ getDropdownLabel() }}</mat-label>
                  <mat-chip-grid #chipGrid formControlName="metaDataValues">
                    @for (value of values; track value) {
                    <mat-chip-row (removed)="remove(value)" [editable]="true" (edited)="edit(value, $event)"
                      [matTooltip]="'Double click or press enter to edit ' + value" [matTooltipShowDelay]="300"
                      [matTooltipHideDelay]="100">
                      {{value}}
                      <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                      </button>
                    </mat-chip-row>
                    }
                    <input placeholder="New Value" [matChipInputFor]="chipGrid"
                      [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                      (matChipInputTokenEnd)="add($event)" />
                  </mat-chip-grid>
                  <mat-error *ngIf="isBooleanError">
                    Only two values are allowed in Boolean Data Type
                  </mat-error>
                  <mat-error *ngIf="metadataForm.get('metaDataValues').hasError('required')">
                    {{ getDropdownLabel() }} is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="col-md-12 d-flex p-0">
            <div class="col-md-4">
              <div class="dense-2" *ngIf="metadataForm.get('metaDataTypeId').value == 9">
                <mat-form-field appearance="outline">
                  <mat-label>Default Date</mat-label>
                  <input matInput [matDatepicker]="picker" autocomplete="off" formControlName="defaultValue"
                    [errorStateMatcher]="matcher">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error *ngIf="metadataForm.get('defaultValue').hasError('required')">
                    Default Value is required
                  </mat-error>
                  <mat-error
                    *ngIf="metadataForm.get('defaultValue')?.invalid && metadataForm.get('defaultValue')?.value">
                    Default Date is invalid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="dense-2" *ngIf="values?.length">
                <mat-form-field appearance="outline">
                  <mat-label>Select Default Value</mat-label>
                  <mat-select formControlName="defaultValue" [errorStateMatcher]="matcher">
                    <mat-option *ngFor="let value of values" [value]="value">
                      {{ value }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="metadataForm.get('defaultValue').hasError('required')">
                    Default Value is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="dense-2" *ngIf="values?.length == 0 && metadataForm.get('metaDataTypeId').value != 9">
                <mat-form-field appearance="outline">
                  <mat-label>Default Value</mat-label>
                  <input type="text" matInput autocomplete="off" formControlName="defaultValue"
                    [errorStateMatcher]="matcher">
                  <mat-error *ngIf="metadataForm.get('defaultValue').hasError('required')">
                    Default Value is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Sequence Number</mat-label>
                  <input type="number" matInput autocomplete="off" formControlName="sequenceNo"
                    [errorStateMatcher]="matcher">
                  <mat-error *ngIf="metadataForm.get('sequenceNo').hasError('required')">
                    Sequence Number is required
                  </mat-error>
                  <mat-error *ngIf="metadataForm.get('sequenceNo')?.hasError('min')">
                    Minimum value is {{ attributeSequenceNumber + 1 }}
                  </mat-error>
                  <mat-error *ngIf="!isSequenceNumberValid">The sequence number {{
                    metadataForm.get('sequenceNo').value }} had already assigned!</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="dense-2">
                <mat-form-field appearance="outline">
                  <mat-label>Help Text</mat-label>
                  <input type="text" matInput autocomplete="off" formControlName="helpText"
                    [errorStateMatcher]="matcher">
                  <mat-error *ngIf="metadataForm.get('helpText').hasError('required')">
                    Help Text is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

          </div>
          <div class="col-md-12 d-flex p-0">
            <div class="col-md-12 d-flex align-items-center justify-content-between">
              <div class="dense-2 d-flex flex-column switch-section">
                <mat-label>Required</mat-label>
                <label class="switch">
                  <input class="switch-input" type="checkbox" formControlName="isRequired"
                    (change)="toggleRequiredHidden('required')">
                  <div class="switch-button">
                    <span class="switch-button-left">Off</span>
                    <span class="switch-button-right">On</span>
                  </div>
                </label>
              </div>
              <div class="dense-2 d-flex flex-column switch-section">
                <mat-label>Editable</mat-label>
                <label class="switch">
                  <input class="switch-input" type="checkbox" formControlName="isEditable"
                    (change)="toggleRequiredHidden('editable')">
                  <div class="switch-button">
                    <span class="switch-button-left">Off</span>
                    <span class="switch-button-right">On</span>
                  </div>
                </label>
              </div>
              <div class="dense-2 d-flex flex-column switch-section">
                <mat-label>Hidden</mat-label>
                <label class="switch">
                  <input class="switch-input" type="checkbox" formControlName="isHidden"
                    (change)="toggleRequiredHidden('hidden')">
                  <div class="switch-button">
                    <span class="switch-button-left">Off</span>
                    <span class="switch-button-right">On</span>
                  </div>
                </label>
              </div>
              <div class="dense-2 d-flex flex-column switch-section">
                <mat-label>Summary Display</mat-label>
                <label class="switch">
                  <input class="switch-input" type="checkbox" formControlName="isDisplaySummary">
                  <div class="switch-button">
                    <span class="switch-button-left">Off</span>
                    <span class="switch-button-right">On</span>
                  </div>
                </label>
              </div>
              <div class="dense-2 d-flex flex-column switch-section">
                <mat-label>Editable Post Execution</mat-label>
                <label class="switch">
                  <input class="switch-input" type="checkbox" formControlName="isEditablePostExecution">
                  <div class="switch-button">
                    <span class="switch-button-left">Off</span>
                    <span class="switch-button-right">On</span>
                  </div>
                </label>
              </div>
              <div class="dense-2 d-flex flex-column switch-section">
                <mat-label>Enable Search</mat-label>
                <label class="switch">
                  <input class="switch-input" type="checkbox" formControlName="isSearchEnabled">
                  <div class="switch-button">
                    <span class="switch-button-left">Off</span>
                    <span class="switch-button-right">On</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="d-flex col-md-12 justify-content-end mt-3" *ngIf="mode != 'view'">
            <button color="primary" class="outlined-btn" mat-raised-button (click)="reset()" type="reset"
              [disabled]="isLoading">Reset</button>
            <button color="accent" mat-raised-button class="ml-3" (click)="saveAttribute($event)" type="submit"
              [disabled]="isLoading">{{ mode ? 'Update' : 'Save' }}
              <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
            </button>
          </div>
        </form>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>